import Dexie, { type EntityTable } from 'dexie';
import type { EncounterRecord } from '../types';

class GCameraDatabase extends Dexie {
  encounters!: EntityTable<EncounterRecord, 'id'>;

  constructor() {
    super('GCameraDB');
    this.version(1).stores({ encounters: 'id, createdAt, paletteName' });
  }
}

export const db = new GCameraDatabase();

export const archiveRepository = {
  async list() { return db.encounters.orderBy('createdAt').reverse().toArray(); },
  async get(id: string) { return db.encounters.get(id); },
  async save(record: EncounterRecord) { await db.encounters.put(record); },
  async remove(id: string) { await db.encounters.delete(id); },
};
